import { render, staticRenderFns } from "./SideBar2.vue?vue&type=template&id=0dcf3eac&scoped=true"
import script from "./SideBar2.vue?vue&type=script&lang=js"
export * from "./SideBar2.vue?vue&type=script&lang=js"
import style0 from "./SideBar2.vue?vue&type=style&index=0&id=0dcf3eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf3eac",
  null
  
)

export default component.exports